import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverListAssignmentFilterEntity } from '../../domain/entities/DriverListAssignmentFilterEntity'

export class DriverListAssignmentFilterModel extends DriverListAssignmentFilterEntity {
  constructor(dataDto: DriverListAssignmentFilterEntity) {
    super()
    mapEntityProperties<DriverListAssignmentFilterModel>(this, dataDto)
  }
}

